module.exports = __webpack_public_path__ + "img/first-third-opened.1d42b0a7.webp";